import { render, staticRenderFns } from "./Chapters.vue?vue&type=template&id=520c884c&scoped=true&"
import script from "./Chapters.vue?vue&type=script&lang=js&"
export * from "./Chapters.vue?vue&type=script&lang=js&"
import style0 from "./Chapters.vue?vue&type=style&index=0&id=520c884c&lang=scss&scoped=true&"
import style1 from "./Chapters.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520c884c",
  null
  
)

export default component.exports